import { CommonUserInfo } from './commonuserinfo';
import { InternalReferralUserInfo } from './internalReferralUserInfo';

export class InternalReferralFriendRequest {
    public sessionToken: string = '';
    public commonUserInfo: CommonUserInfo = new CommonUserInfo();
    public friendList: InternalReferralUserInfo[] = [];
    public companyCode: string ='';
    public jobPostingId: number = 0;
    public referralType: string = '';
    public internalReferral: boolean = true;
    public referralCode: string = '';
    public utmTrackerId!: number;
    public sourceChannelValue:string = 'Talent Portal';
}
